export class ModuleActivationRewards {
  onStart(tokens_per_second) {}
  onDepositTokens(tokens_amount) {}
  onEnd() {}
}
